module.exports = __webpack_public_path__ + "static/img/background.43aca288.svg";